import { RightArrow } from 'assets/icons';
import CustomLink from 'components/shared/CustomLink';

export const womensHealthFaqDataPro = [
  {
    title:
      'What is new in the C&O Pro PowerPlug compared to previously available C&O PowerPlug?',
    description: (
      <>
        C&O Pro, powered by OvuSense™ Technology, builds on the capabilities of
        the original C&O PowerPlug by adding clinically validated
        temperature-based ovulation confirmation, Cycle Flags™ and detailed
        cycle health insights. While both versions offer period and ovulation
        day prediction, C&O Pro goes further with:
        <ul>
          <li>Support for irregular and diverse cycles</li>
          <li>Ovulation confirmation with over 90% accuracy</li>
          <li>Anovulatory cycle detection</li>
          <li>
            Cycle Flags™ to highlight key ovulatory patterns and possible
            irregularities
          </li>
          <li>
            CE and UKCA certified as a Class IIa medical device in EU & UK.
            MDSAP certified and registered for US FDA, Canada and Australia to
            Class II standards.
          </li>
          <li>HSA/FSA eligible in USA</li>
        </ul>
        <p>
          These upgrades make C&O Pro especially valuable for users tracking
          fertility in irregular cycles, or monitoring patterns linked to
          cycle-related health conditions, while maintaining the accuracy and
          privacy standards of Ultrahuman&apos;s ecosystem.
        </p>
      </>
    ),
  },
  {
    title: 'Can I use C&O Pro for HSA/FSA reimbursement?',
    description: (
      <>
        C&O Pro is eligible for HSA/FSA reimbursement in the United States. You
        can also export your cycle reports to share with your healthcare
        provider for ongoing care.
      </>
    ),
  },
  {
    title: 'Can I view or export my Cycle Report?',
    description: (
      <>
        Yes. You can download a comprehensive analysis of your past 6 cycles. A
        PDF export option is available so you can share results with your
        healthcare provider. Your first report will be available to you after 30
        days of activation.
      </>
    ),
  },
  {
    title:
      'What is the difference between ovulation confirmation and fertile window prediction?',
    description: (
      <>
        <p>
          <strong>Ovulation confirmation </strong>means verifying after it has
          happened that ovulation occurred in your cycle, usually by detecting a
          sustained rise in temperature or other biomarkers.
        </p>
        <p>
          <strong>Fertile window prediction</strong> means estimating in advance
          the days you are most likely to conceive, based on your cycle history
          and real-time biomarker trends.
        </p>
        <p>
          In short, prediction helps you plan ahead, while confirmation tells
          you what actually happened. C&O Pro both predicts and confirms
          ovulation.
        </p>
      </>
    ),
  },
  {
    title: 'Which regions is C&O Pro available in?',
    description: (
      <>
        C&O Pro is currently available in the United States, United Kingdom,
        Australia, Canada, the European Union, Norway, Iceland, and Isle of Man,
        with more regions coming
        soon.
      </>
    ),
  },
  {
    title: ' ',
    description: (
      <div className="" style={{ textAlign: 'left' }}>
        <CustomLink
          target={'_blank'}
          href={{
            pathname:
              'https://ultrahumanapp.notion.site/Cycle-Ovulation-Pro-FAQs-245755317a91800e8214e2b73f170ce2',
          }}
        >
          See all FAQs <RightArrow fill="#000000" />
        </CustomLink>
      </div>
    ),
  },
];

export const womensHealthFaqDataPlus = [
  {
    title:
      'What is new in the C&O Plus PowerPlug compared to the previously available C&O PowerPlug?',
    description: (
      <>
        C&O Plus builds on the capabilities of the original C&O PowerPlug by
        adding temperature-based cycle pattern recognition, Cycle Flags, and
        detailed cycle and fertility insights. While both versions offer
        cycle-phase estimation, C&O Plus goes further with:
        <ul>
          <li>Support for irregular and diverse cycles</li>
          <li>Recognizes ovulation patterns with 90%+ consistency</li>
          <li>Highlights cycles without a clear ovulation pattern</li>
          <li>
            Cycle Flags to highlight key cycle patterns and possible variations
          </li>
          <li>
            Designed for wellness and fertility awareness use only – not a
            medical or diagnostic device
          </li>
          <li>Eligible for HSA/FSA benefits in the USA</li>
        </ul>
        <p>
          These upgrades make C&O Plus especially valuable for users tracking
          fertility awareness in irregular cycles or observing pattern-based
          changes related to their overall wellness, while maintaining the
          consistency and privacy standards of Ultrahuman&apos;s ecosystem.
        </p>
      </>
    ),
  },
  {
    title:
      'What is the difference between ovulation pattern recognition and fertility phase estimation?',
    description: (
      <>
        <p>
          <strong>Ovulation pattern recognition</strong> means observing a
          sustained temperature trend that suggests ovulation has occurred within
          a cycle.
        </p>
        <p>
          <strong>Fertility phase estimation</strong> means highlighting the days
          when fertility-related patterns may be more likely to appear, based on
          your unique biomarker trends and past cycle data.
        </p>
        <p>
          In short, estimation helps you understand potential fertile phases,
          while pattern recognition shows what your body experienced in that
          cycle. C&O Plus offers both to support cycle and fertility awareness.
        </p>
      </>
    ),
  },
  {
    title: 'Can I view or export my Cycle Report?',
    description: (
      <>
        Yes — you can download a summary report of your past six cycles, showing
        patterns observed across temperature and fertility phases. A PDF export
        option is available so you can share your cycle trends with a healthcare
        professional. Your first report becomes available 30 days after
        activation.
      </>
    ),
  },
  {
    title: 'Why does C&O Plus work for all kinds of cycles?',
    description: (
      <>
        C&O Plus works effectively across a wide range of cycle types because
        its data model is built on a diverse set of real-world cycle patterns,
        including irregular, short, long, and variable cycles. This model is
        designed to observe temperature-based trends and adapt to your body&apos;s
        unique rhythm, rather than relying on fixed cycle lengths. By focusing on
        biometric patterns and consistency, C&O Plus helps you recognize
        fertility-related insights and cycle variations with awareness and
        confidence.
      </>
    ),
  },
  {
    title: 'How is my data used to label Cycle Flags on my cycles?',
    description: (
      <>
        The system analyses overnight temperature trends and other biomarker
        data recorded by Ring AIR to highlight consistent patterns in your
        cycle. Based on these trends, it applies Cycle Flags to reflect
        variations in fertility-related phases or temperature shifts, helping you
        understand your body&apos;s rhythm and cycle consistency.
      </>
    ),
  },
  {
    title: ' ',
    description: (
      <div className="" style={{ textAlign: 'left' }}>
        <CustomLink
          target={'_blank'}
          href={{
            pathname:
              'https://ultrahumanapp.notion.site/Cycle-Ovulation-Plus-FAQs-2a9755317a91806dbee7d350dc99eecc',
          }}
        >
          See all FAQs <RightArrow fill="#000000" />
        </CustomLink>
      </div>
    ),
  },
];

// Default export for backward compatibility
export const womensHealthFaqData = womensHealthFaqDataPro;
